import { logExceptionOnce } from '@hungryroot/o11y';
import {
  DynamicConfigs,
  useDynamicConfiguration,
} from '@hungryroot/rest-hooks';

const CONFIG_NAME = DynamicConfigs.FoodProfileAvoidanceCommonSearchTerms;

/**
 * Common-search pills for Ingredient Dislikes. The value is a JSON list of
 * strings on `food_profile.avoidance.common_search_terms`. A missing or
 * malformed value hides the pills instead of falling back to a hardcoded list.
 */
export function parseAvoidanceCommonSearchTerms(
  rawValue: string | undefined
): string[] {
  if (rawValue == null || rawValue === '') return [];

  try {
    const parsed: unknown = JSON.parse(rawValue);
    if (!Array.isArray(parsed)) {
      reportUnparseableCommonSearchTerms();
      return [];
    }
    return parsed.filter(
      (term): term is string => typeof term === 'string' && term !== ''
    );
  } catch (error) {
    reportUnparseableCommonSearchTerms(error);
    return [];
  }
}

export function useAvoidanceCommonSearchTerms() {
  const { data } = useDynamicConfiguration(CONFIG_NAME);
  return parseAvoidanceCommonSearchTerms(data?.value);
}

function reportUnparseableCommonSearchTerms(error?: unknown) {
  logExceptionOnce(
    `Unable to parse ${CONFIG_NAME} dynamic config`,
    { key: 'useAvoidanceCommonSearchTerms.json.parse.error' },
    { error: error instanceof Error ? error.message : undefined }
  );
}
